import { render, staticRenderFns } from "./ModalThemen.vue?vue&type=template&id=8ddc22c2&"
import script from "./ModalThemen.vue?vue&type=script&lang=js&"
export * from "./ModalThemen.vue?vue&type=script&lang=js&"
import style0 from "./ModalThemen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports